<template>
  <div class="log">
  </div>
</template>

<script>
  export default {
    created () {
      this.$store.dispatch('logoutUser')
        .then(() => {
          this.$router.push({ name: 'home' })
          location.replace('/')
        })
    }
  }
</script>

<style scoped>
</style>